import { render, staticRenderFns } from "./NationalSystem.vue?vue&type=template&id=5b6ceb06"
import script from "./NationalSystem.vue?vue&type=script&lang=js"
export * from "./NationalSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports